var $bef83c54db7b4873$exports = {};
$bef83c54db7b4873$exports = {
    "clear": `Effacer`,
    "invalid": `(non valide)`,
    "loading": `Chargement en cours...`,
    "noResults": `Aucun r\xe9sultat`,
    "valid": `(valide)`
};


export {$bef83c54db7b4873$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
